import { ContentType, IdeationStatus, ModerationLabel, ModeratorTag } from './types'
import {
  createPublishedInFilter,
  createContentTypeFilter,
  createAssignedModeratorFilter,
  createModerationLabelFilter,
  createModeratorTagFilter,
  createPublicTagFilter,
  createPublishedAtFilter,
  createLastActivityAtFilter,
  createIdeationStatusFilter,
  createRepliesFilter,
  createLikesFilter,
  createVotesFilter,
  createBestAnswerFilter,
  createPinnedReplyFilter,
  createUnreadByTeamFilter,
  createProductAreaFilter
} from './Filters'
import { CloseTopic, TrashTopic, createMoveToComponent, MarkAsSpam } from './BulkActions'
import {
  createAssignedModeratorColumn,
  createAuthorColumn,
  createContentTypeColumn,
  createLastActivityColumn,
  createLikesColumn,
  createModerationLabelColumn,
  createModeratorTagsColumn,
  createProductAreasColumn,
  createPublicTagsColumn,
  createPublishDateColumn,
  createPublishedInColumn,
  createRepliesColumn,
  createTitleColumn,
  createUnreadByTeamColumn,
  createVotesColumn
} from './Columns'
/* eslint-disable import/no-internal-modules */
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import globals from '@insided/deprecated-utils/globals'
import Overview from '@insided/deprecated-control/overview'
import { ParentCategory } from '@insided/deprecated-preact-components/category-selector/CategorySelector'
import { common } from '@insided/deprecated-preact-components/common'
import { createSeparator } from '@insided/deprecated-control/overview/filters/utils'

interface Props {
  categories: ParentCategory[]
  contentTypes: ContentType[]
  moderationLabels: ModerationLabel[]
  moderatorTags: ModeratorTag[]
  ideationStatuses: IdeationStatus[]
  allProductAreas: []
}

const ModerationOverview = ({
  categories,
  contentTypes,
  moderationLabels,
  moderatorTags,
  ideationStatuses,
  allProductAreas
}: Props) => {
  function getFilters() {
    const filters = [
      createPublishedInFilter(categories),
      createContentTypeFilter(contentTypes),
      createSeparator(),
      createAssignedModeratorFilter(),
      createUnreadByTeamFilter(),
      createModerationLabelFilter(moderationLabels),
      createModeratorTagFilter(moderatorTags),
      createPublicTagFilter(),
      createSeparator(),
      createPublishedAtFilter(),
      createLastActivityAtFilter(),
      createIdeationStatusFilter(ideationStatuses),
      createSeparator(),
      createRepliesFilter(),
      createLikesFilter(),
      createVotesFilter(),
      createSeparator(),
      createBestAnswerFilter(),
      createPinnedReplyFilter(),
      createProductAreaFilter()
    ]

    if (!common.isModuleActive('productAreas')) {
      filters.splice(-1, 1) // remove Product areas column if module is disabled
    }

    return filters
  }

  function getColumns() {
    const columns = [
      createTitleColumn(),
      createProductAreasColumn(allProductAreas, true),
      createContentTypeColumn(),
      createUnreadByTeamColumn(),
      createPublishedInColumn(),
      createLikesColumn(true),
      createRepliesColumn(),
      createVotesColumn(true),
      createLastActivityColumn(),
      createAssignedModeratorColumn(true),
      createPublishDateColumn(true),
      createAuthorColumn(true),
      createModeratorTagsColumn(true),
      createModerationLabelColumn(true),
      createPublicTagsColumn(true)
    ]
    if (!common.isModuleActive('productAreas')) {
      columns.splice(1, 1) // remove Product areas column if module is disabled
    }
    return columns
  }

  function getBulkActions() {
    return [
      createMoveToComponent(categories),
      CloseTopic,
      MarkAsSpam,
      TrashTopic
    ]
  }

  return (
    <Overview
      type='moderation'
      headerTitle='Overview'
      withPagination={{
        page: 1,
        pageSize: 25
      }}
      withSorting={{
        unreadByTeam: 'desc'
      }}
      withFilters={getFilters()}
      withSearch
      searchPlaceholder='Search in title and content'
      withColumns
      rowId='publicId'
      model={getColumns()}
      endpoint='/overview/topics'
      dataKey='topics'
      bulkActions={getBulkActions()}
      EmptyStateComponent={
        <EmptyPage
          img_src={`${globals('defaultCdn') as string}/images/empty_page.png`}
          header='There are no topics yet'
          text={
            'Seems like no one on your team has created a topic. \n Start now by creating a new topic.'
          }
          button={{ link: '/content/new/article', text: 'New article' }}
        />
      }
      withCustomViews='default'
    />
  )
}

export default ModerationOverview
